import { Property } from 'csstype';
import { CSSProperties, FC, HTMLAttributes } from 'react';

interface Props {
    fd?: Property.FlexDirection;
    styles?: CSSProperties;
    w?: string | number;
}

export const Table: FC<Props & HTMLAttributes<HTMLDivElement>> = ({
    fd = 'column',
    w = '100%',
    styles,
    children,
    ...props
}) => {
    const styleObj = {
        ...styles,
        display: 'flex',
        flexDirection: fd,
        width: w,
    };

    return (
        <div style={styleObj} {...props}>
            {children}
        </div>
    );
};
